import api from "./api";
import qsStringify from "./qsStringify";

export const getProducts = (locale, queries) => {
  const query = qsStringify({
    sort: ["publishedAt:asc"],
    ...queries,
  });

  return api
    .get(`/api-productss?locale=${locale}&${query}`)
    .then(res => res.data);
};

export const orderProduct = body =>
  api.post(`/api-product-orders`, body).then(res => res.data);

export const getFilters = (endpoint, locale) => {
  return api
    .get(`${endpoint}?locale=${locale}&populate=products`)
    .then(res => res.data);
};
